import { render, staticRenderFns } from "./getVideoUrl.vue?vue&type=template&id=591c042a&scoped=true"
import script from "./getVideoUrl.vue?vue&type=script&lang=js"
export * from "./getVideoUrl.vue?vue&type=script&lang=js"
import style0 from "./getVideoUrl.vue?vue&type=style&index=0&id=591c042a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591c042a",
  null
  
)

export default component.exports